export default "__VITE_ASSET__CEZ1YpU7__"